import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_364bf40f from 'nuxt_plugin_plugin_364bf40f' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_image_462f7aa0 from 'nuxt_plugin_image_462f7aa0' // Source: ./image.js (mode: 'all')
import nuxt_plugin_pluginserver_b03c035a from 'nuxt_plugin_pluginserver_b03c035a' // Source: ./nuxt-speedkit/plugin.server.js (mode: 'server')
import nuxt_plugin_pluginclient_42288ccb from 'nuxt_plugin_pluginclient_42288ccb' // Source: ./nuxt-speedkit/plugin.client.js (mode: 'client')
import nuxt_plugin_axios_5b287da5 from 'nuxt_plugin_axios_5b287da5' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_mixins_5013a1f0 from 'nuxt_plugin_mixins_5013a1f0' // Source: ../plugins/mixins (mode: 'all')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_vuemoment_1fc97fc6 from 'nuxt_plugin_vuemoment_1fc97fc6' // Source: ../plugins/vue-moment (mode: 'all')
import nuxt_plugin_vueawesomeswiper_4af85e3f from 'nuxt_plugin_vueawesomeswiper_4af85e3f' // Source: ../plugins/vue-awesome-swiper (mode: 'client')
import nuxt_plugin_vuescrollto_53dc20e5 from 'nuxt_plugin_vuescrollto_53dc20e5' // Source: ../plugins/vue-scrollto (mode: 'client')
import nuxt_plugin_vuectkdatetimepicker_20b2be9f from 'nuxt_plugin_vuectkdatetimepicker_20b2be9f' // Source: ../plugins/vue-ctk-date-time-picker (mode: 'client')
import nuxt_plugin_vuelineclamp_7c690d3f from 'nuxt_plugin_vuelineclamp_7c690d3f' // Source: ../plugins/vue-line-clamp (mode: 'client')
import nuxt_plugin_vuemultiselect_f0c5f110 from 'nuxt_plugin_vuemultiselect_f0c5f110' // Source: ../plugins/vue-multiselect (mode: 'client')
import nuxt_plugin_vuedatepick_05ae00ba from 'nuxt_plugin_vuedatepick_05ae00ba' // Source: ../plugins/vue-date-pick (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Malayan Insurance | Website","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=6.0"},{"name":"format-detection","content":"telephone=no"},{"hid":"description","name":"description","content":"Malayan Insurance"},{"name":"insight-app-sec-validation","content":"172ecb88-9fdd-4cad-b8b2-929f1e2d7ec3"},{"name":"google-site-verification","content":"2tiqb4HGP9ELmcgFVZ5DtW5ssVa3bZ_xfHLrq9Tkzmo"},{"name":"google-site-verification","content":"8EupzWvF8-7SetLp-0SVHrScsO6Vivb0XvKZhXSkvkQ"}],"link":[{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon.webp"}],"script":[{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-QZ98CG03YX","defer":false,"async":true},{"src":"\u002Fseo\u002Fgoogle-analytics.js","defer":true},{"src":"\u002Fseo\u002Fgtag.js","defer":true},{"src":"\u002Fseo\u002Fchatbot.js","defer":true},{"type":"application\u002Fld+json","json":{"@context":"https:\u002F\u002Fschema.org","@type":"InsuranceAgency","name":"Malayan Insurance","image":"https:\u002F\u002Fmalayan.com\u002F_ipx\u002Fcbimage.png","url":"https:\u002F\u002Fmalayan.com\u002F","telephone":"632 8628 8628","address":{"@type":"PostalAddress","streetAddress":"4F Yuchengco Tower I 484 Quintin Paredes St. Binondo","addressLocality":"Manila","postalCode":"1006","addressCountry":"PH"},"geo":{"@type":"GeoCoordinates","latitude":14.5988884,"longitude":120.975891},"openingHoursSpecification":{"@type":"OpeningHoursSpecification","dayOfWeek":["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],"opens":"00:00","closes":"23:59"},"sameAs":["https:\u002F\u002Fwww.facebook.com\u002FMalayanInsurancePH\u002F","https:\u002F\u002Fwww.instagram.com\u002Fmalayaninsuranceph\u002F","https:\u002F\u002Fwww.linkedin.com\u002Fcompany\u002Fmalayan-insurance-co-inc-\u002Fposts\u002F?feedView=all"]}}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_364bf40f === 'function') {
    await nuxt_plugin_plugin_364bf40f(app.context, inject)
  }

  if (typeof nuxt_plugin_image_462f7aa0 === 'function') {
    await nuxt_plugin_image_462f7aa0(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_b03c035a === 'function') {
    await nuxt_plugin_pluginserver_b03c035a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_42288ccb === 'function') {
    await nuxt_plugin_pluginclient_42288ccb(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5b287da5 === 'function') {
    await nuxt_plugin_axios_5b287da5(app.context, inject)
  }

  if (typeof nuxt_plugin_mixins_5013a1f0 === 'function') {
    await nuxt_plugin_mixins_5013a1f0(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_6e5ad03a === 'function') {
    await nuxt_plugin_veevalidate_6e5ad03a(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemoment_1fc97fc6 === 'function') {
    await nuxt_plugin_vuemoment_1fc97fc6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomeswiper_4af85e3f === 'function') {
    await nuxt_plugin_vueawesomeswiper_4af85e3f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_53dc20e5 === 'function') {
    await nuxt_plugin_vuescrollto_53dc20e5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuectkdatetimepicker_20b2be9f === 'function') {
    await nuxt_plugin_vuectkdatetimepicker_20b2be9f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelineclamp_7c690d3f === 'function') {
    await nuxt_plugin_vuelineclamp_7c690d3f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuemultiselect_f0c5f110 === 'function') {
    await nuxt_plugin_vuemultiselect_f0c5f110(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuedatepick_05ae00ba === 'function') {
    await nuxt_plugin_vuedatepick_05ae00ba(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
